import type { Component, JSX } from "solid-js";
import { splitProps } from "solid-js";
import { cn } from "../../libs/cn";

export interface SkeletonProps extends JSX.HTMLAttributes<HTMLDivElement> {
  /**
   * Optional width in pixels. If not provided, use CSS classes (e.g., w-full, w-32)
   */
  width?: number;
  /**
   * Optional height in pixels. If not provided, use CSS classes (e.g., h-full, h-8)
   */
  height?: number;
  /**
   * Optional border radius. If not provided, use CSS classes (e.g., rounded, rounded-lg)
   */
  radius?: number;
}

export const LoadingSkeleton: Component<SkeletonProps> = (props) => {
  const [local, rest] = splitProps(props, [
    "class",
    "width",
    "height",
    "radius",
  ]);

  const style = (): JSX.CSSProperties => {
    const styles: Record<string, string> = {};
    if (local.width !== undefined) {
      styles.width = `${local.width}px`;
    }
    if (local.height !== undefined) {
      styles.height = `${local.height}px`;
    }
    if (local.radius !== undefined) {
      styles["border-radius"] = `${local.radius}px`;
    }
    return styles as JSX.CSSProperties;
  };

  return (
    <div
      class={cn("animate-pulse bg-gray-200", local.class)}
      style={style()}
      {...rest}
    />
  );
};
